exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/node_modules/core-js/modules/_wks-ext.js
// module id = 98
// module chunks = 0